module.exports = __webpack_public_path__ + "img/covid19-dashboard-thumbnail.d9f51422.png";